// Description: Modal for displaying the funneling graph

// Core imports
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Modal } from 'antd';
import ActivityFlowEditor from '../UI/ActivityFlowEditor';

// Misc imports
import { useBotLanguage } from '../../utils/hooks/useBotLanguage';
import { getCurrentQueryState } from '../../store/utils/getCurrentQueryState';
import { useParams } from 'react-router-dom';

const AnalyticsFunnelingGraphModal = ({
  isModalVisible= false,
  handleModalCancel= () => {},
  graphData = {}
}) => {
  const { orgId } = useParams();
  const { data: bot } = getCurrentQueryState('fetchBot', { orgId, tenantId: graphData?.tenantId });
  const { changeBotLanguage } = useBotLanguage(graphData?.tenantId);

  // When the bot changes, update the language to the primary language of the bot
  useEffect(() => {
    if (bot?.settings?.languages?.primary) {
      changeBotLanguage(bot.settings.languages.primary);
    }
  }, [bot]);

  return (
    <Modal
      destroyOnClose={true}
      open={isModalVisible}
      onCancel={handleModalCancel}
      footer={null}
      title={graphData?.tenantDisplayName}
      centered
      width={'80%'}
    >
      <div>
        <ActivityFlowEditor
          injectedNodeData={graphData?.injectedNodeData}
          isViewOnlyMode={true}
          bot={{
            id: graphData?.tenantId
          }}
          activityId={graphData?.activityId}
        />
      </div>
    </Modal>
  );
};

AnalyticsFunnelingGraphModal.propTypes = {
  isModalVisible: PropTypes.bool,
  handleModalCancel: PropTypes.func,
  graphData: PropTypes.object
};

export default React.memo(AnalyticsFunnelingGraphModal);
